// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  assembleQuery,
  fetchProjectsByQuery,
  makePaginationParams,
} from 'helpers/api'

import { makeProjectManagementFormQuery } from './helpers'

// NOTE - this fetchData does not handle MUST_SEARCH_AT_LEAST_ONE_VALUE
// because the user name is required to search.

const fetchData = ({ formProps, formValues, submittedFormIsPristine }) => {
  // if submitSucceeded was true, that means we want to make sure to persist the
  // defined page value for the query. Otherwise, reset the page.
  const page = (
    formValues.pagination && submittedFormIsPristine(formProps.form)
      ? +formValues.pagination.page
      : 0
  )
  // size of results set in API response - default to 100 count
  const size = 100
  const paginationParams = makePaginationParams({
    page,
    size,
  })

  const query = [
    ...paginationParams,
    makeProjectManagementFormQuery(formValues),
  ]

  return fetchProjectsByQuery(assembleQuery(query))
}

export default fetchData
